module.exports = __webpack_public_path__ + "static/1-4c4807d00a3515f4c2d1c3378724b91f.jpg";